var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperationsSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "operations_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-operations-(green)",
    transform: "translate(0.000000, -3.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 L19,6 L22,10.056002 L22,15.999962 L19.965,15.999962 C19.8461,16.834262 19.4302,17.597662 18.7937,18.149962 C18.1571,18.702162 17.3427,19.006262 16.5,19.006262 C15.6573,19.006262 14.8429,18.702162 14.2063,18.149962 C13.5698,17.597662 13.1539,16.834262 13.035,15.999962 L7.965,15.999962 C7.84612,16.834262 7.43021,17.597662 6.79368,18.149962 C6.15714,18.702162 5.34272,19.006262 4.5,19.006262 C3.65728,19.006262 2.84286,18.702162 2.20632,18.149962 C1.56979,17.597662 1.15388,16.834262 1.035,15.999962 L0,15.999962 L0,4 C0,3.734782 0.105357,3.480432 0.292893,3.292893 C0.48043,3.105357 0.734784,3 1,3 L15,3 C15.2652,3 15.5196,3.105357 15.7071,3.292893 C15.8946,3.480432 16,3.734782 16,4 L16,6 Z M16,8.000002 L16,11.000002 L20,11.000002 L20,10.715002 L17.992,8.000002 L16,8.000002 Z",
    id: "operations_selected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsSelected);
export default __webpack_public_path__ + "static/media/operations_selected.ec50849dbd8f4c9ad2ddc4d4c583c596.svg";
export { ForwardRef as ReactComponent };